<template>
  <div aria-label="breadcrumb" v-if="breadcrumbs.length > 0">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" v-for="(item, idx) in breadcrumbs" :key="idx">
        <router-link :to="item.link" v-if="item.link != undefined">{{
          item.name
        }}</router-link>
        <span v-else>{{ item.name }}</span>
      </li>
    </ol>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { ref, onMounted, watch } from "vue";

export default {
  props: {
    category: {
      type: String,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
    link: {
      type: String,
      required: false,
    },
    keyword: {
      type: String,
      required: false,
    },
    location: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const route = useRoute();
    const breadcrumbs = ref([]);

    watch(
      () => props.location,
      (newVal) => {
        breadcrumbs.value[2].name = "地區：" + newVal;
      }
    );

    onMounted(() => {
      console.log(props.category);
      if (
        route.meta.breadcrumb != undefined &&
        route.meta.breadcrumb.length > 0
      ) {
        breadcrumbs.value = route.meta.breadcrumb;
        if (breadcrumbs.value.length > 1 && props.category != undefined) {
          breadcrumbs.value[1].name = props.category;
        } else if (breadcrumbs.value.length > 1 && props.keyword != undefined) {
          breadcrumbs.value[1].name = "搜尋：" + props.keyword;
        }
        if (breadcrumbs.value.length > 2 && props.code != undefined) {
          breadcrumbs.value[2].name = props.code;
          if (props.link != undefined && props.link != "code") {
            if (props.category == "自駕遊")
              breadcrumbs.value[1].link = "/product/car-rental";
            else breadcrumbs.value[1].link = "/product/" + props.link;
          }
        }
        if (breadcrumbs.value.length > 2 && props.location != undefined) {
          breadcrumbs.value[2].name = "地區：" + props.location;
        }
      }
    });

    return {
      breadcrumbs,
    };
  },
};
</script>

